module.exports = __webpack_public_path__ + "static/media/autokar2 (1).947a1772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (1).jpg
// module id = 848
// module chunks = 0